module.exports = {
	SUPPORTED_LANGUAGES: ['en', 'ar', 'et'], // SC-12742: lt/it/ru/fr/es-ES removed; todo add 'uk-UA' when translated
};
